import React, { Component } from 'react';
import { Row, Col, Layout, Upload, Icon, message, Button, Spin, Modal } from 'antd';
import { inject, observer } from 'mobx-react';

import K from '../../../services/constants';
import { api } from '../../../services';
import './DownloadAndUpload.css';

const savePdf = (function() {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  return function(data, fileName) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();

@inject('translationsStore', 'commonStore', 'step5RegistrationStore')
@observer
export default class DownloadAndUpload extends Component {
  constructor(props) {
    super(props);

    this.refs = {};

    this.state = {
      inProgress: false,

      installationcheck: [],
      subscription: [],
      loadingInstallationsCheck: false,
      loadingSubscriptions: false
    };

    this.commonUplaodProps = {
      multiple: false,
      headers: { Authorization: `Bearer ${this.props.commonStore.token.access_token}` },
      beforeUpload: (file, fileList) => {
        const isPDF = file.type === 'application/pdf';
        const isLt2M = file.size / 1024 / 1024 <= 4;
        if (!isPDF) {
          message.error('You can only upload PDF file!');
        }
        if (!isLt2M) {
          message.error('File must be smaller than 4MB!');
        }
        !(isPDF && isLt2M) && fileList.splice(0, 1);
        return isPDF && isLt2M;
      }
    };

    this.setListFileState = (type, { operation = 'add', where = 1 } = { operation: 'add', where: 1 }) => attachment => {
      let index = undefined;
      let filesList = this.state[type];
      if (operation === 'add') {
        filesList.splice(where, 0, attachment);
      } else if (operation === 'delete') {
        index = filesList.findIndex(f => f.id === attachment.id);
        filesList.splice(index, 1);
      }
      let obj = {};
      obj[type] = filesList.slice(-1);
      this.setState(obj);
      return index;
    };

    this.removeFile = (type, attachment) => {
      let index = this.setListFileState(type, { operation: 'delete' })(attachment);
      return api({ action: 'delete attachment' }, type, attachment.name)
        .then(result => true)
        .catch(error => {
          this.setListFileState(type, { where: index })(attachment);
          message.error(error);
          return false;
        });
    };

    this.uploadProps = type =>
      Object.assign({}, this.commonUplaodProps, {
        action: `${K.API_URL}/api/v1/agreements/${this.props.userId}?type=${type}&asset=${this.props.imei}`,
        defaultFileList: this.state[type],
        onPreview: file => {
          const type = file.url.substring(0, file.url.indexOf('/'));
          api({ action: 'download attachment' }, type, file.name).then(data => {
            savePdf(data, `${file.name}`);
          });
        },
        onRemove: file => this.removeFile(type, file),
        onChange: async info => {
          let fileList = [...info.fileList];
          fileList.slice(0, -1).forEach(eachFile => {
            (() => {this.removeFile(type, eachFile)})(eachFile);
          });
          // console.log('onchange', toBeRemoved, fileList.slice(-1), info);
          fileList = fileList.slice(-1);
          this.setFileList({ type, fileList, cb: () => {
              if (info.file.status === 'done') {
                const { filename } = info.file.response;
                info.fileList[info.fileList.length - 1].name = filename;
                info.fileList[info.fileList.length - 1].url = `${type}/${filename}`;
                this.setListFileState(type)(info.file);
              }
            } });
        },
        fileList: this.state[type]
      });

    this.uploadInstallationcheckProps = () => this.uploadProps('installationcheck');
    this.uploadSubscriptionProps = () => this.uploadProps('subscription');
  }

  componentDidMount() {
    const mapfile = type => (attachment, index) => {
      return {
        name: attachment.Name,
        uid: index,
        id: attachment.Key,
        url: `${type}/${attachment.Name}`
      };
    };

    this.setState({ loadingInstallationsCheck: true });
    api({ action: 'get installations check' }, this.props.step5RegistrationStore.user._id, this.props.step5RegistrationStore.asset.imei)
      .then(result => {
        result.attachments.map(mapfile('installationcheck')).forEach(this.setListFileState('installationcheck'));
        return true;
      })
      .catch(error => {
        console.log(error);
        return { error };
      })
      .then(({ error }) => {
        this.setState({ loadingInstallationsCheck: false });
        if (!error) {
        }
      });

    this.setState({ loadingSubscriptions: true });
    api({ action: 'get subscriptions' }, this.props.step5RegistrationStore.user._id, this.props.step5RegistrationStore.asset.imei)
      .then(result => {
        result.attachments.map(mapfile('subscription')).forEach(this.setListFileState('subscription'));
        return true;
      })
      .catch(error => {
        console.log(error);
        return { error };
      })
      .then(({ error }) => {
        this.setState({ loadingSubscriptions: false });
        if (!error) {
        }
      });
  }

  onConfirmHandler(e) {
    this.props.callback();
  }

  setFileList = ({type, fileList, cb}) => {
    this.setState({ [type]: fileList }, () => {
      cb();
    });
  };

  render() {
    const {
      translationsStore: { current: t }
    } = this.props;

    const uploadDocument = (props, uploadText = <div>{t['shared']['lblDragFileToArea']}</div>) => (
      <Upload.Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">{uploadText}</p>
      </Upload.Dragger>
    );

    return (
      <Layout className="DownloadAndUpload">
        <Layout.Content>
          <Row className="description">
            <ul>
              <li>
                <p>
                  <strong>{t['shared']['lbluploadDoc']}</strong>
                </p>
              </li>
            </ul>
          </Row>

          <Spin spinning={this.state.loadingInstallationsCheck && this.state.loadingSubscriptions}>
            <Row className="upload">
              <Col>
                {uploadDocument(
                  this.uploadSubscriptionProps(),
                  <span>
                    {t['shared']['lblDragFileToArea']} <strong>{t['registration_3']['btnGeneralModule']}</strong>
                  </span>
                )}
              </Col>
              <Col>
                {uploadDocument(
                  this.uploadInstallationcheckProps(),
                  <span>
                    {t['shared']['lblDragFileToArea']} <strong>{t['registration_3']['btnAgreementModule']}</strong>
                  </span>
                )}
              </Col>
            </Row>
          </Spin>
        </Layout.Content>
        <Layout.Footer>
          <Button
            disabled={this.state.installationcheck.length === 0 || this.state.subscription.length === 0}
            type="primary"
            icon="mail"
            onClick={this.onConfirmHandler.bind(this)}
          >
            {t['shared']['confirmAndSendEmail']}
          </Button>
        </Layout.Footer>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_5/DownloadAndUpload.js